module.exports = __webpack_public_path__ + "img/sbg0102.384ef62c.png";